interface ImageViewerCornerProps {
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
  UNSAFE_className?: string;
  children: React.ReactNode;
}

const ImageViewerCorner = ({
  position = 'top-right',
  UNSAFE_className = '',
  children,
}: ImageViewerCornerProps) => {
  const [vertical, horizontal] = position.split('-');

  return (
    <div
      className={`
      tw-absolute tw-z-10
      ${
        vertical === 'top'
          ? 'tw-top-0 desktop:tw-top-4'
          : 'tw-bottom-0 desktop:tw-bottom-4'
      }
      ${
        horizontal === 'right'
          ? 'tw-right-0 desktop:tw-right-4'
          : 'tw-left-0 desktop:tw-left-4'
      }
      ${UNSAFE_className}
    `}
    >
      {children}
    </div>
  );
};

export default ImageViewerCorner;
